module.exports = __webpack_public_path__ + "img/jpg.5834c644.png";